import { motion } from "framer-motion";
import "../styles/WhoWeServe.css";

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const WhoWeServe = () => {
  const clients = [
    "Early-stage startups & scaleups",
    "Small and medium-sized enterprises (SMEs)",
    "Large corporations seeking African expansion",
    "Government and public sector agencies",
    "Development organizations and NGOs",
    "Academic institutions and youth platforms",
    "Impact investors and venture capital firms",
  ];

  return (
    <section className="who-we-serve">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Who We Serve
        </motion.h2>
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          We partner with a diverse range of clients and stakeholders,
          including:
        </motion.p>

        <div className="cards-grid">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="card"
            >
              {client}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
